import React from 'react';
import PropTypes from 'prop-types';
import { DropdownSort, TooltipHelp } from '@weezevent/nacre';
import Style from '../pages/attendee/list/list.module.css';

export default function SortDropdown({ name, ordering, label, items, tooltip, className }) {
    const active = React.useMemo(() => (Array.isArray(name) ? name.includes(ordering) : [name, `-${name}`].includes(ordering)), [name, ordering]);
    const icon = React.useMemo(() => {
        if (!active) {
            return null;
        }
        return ordering[0] === '-' ? 'arrow-top' : 'arrow-bottom';
    });

    return (
        <th className={`${Style['width-small']} ${className}`}>
            <DropdownSort active={active} label={label} items={items} name={name} ordering={ordering} icon={icon} />
            {tooltip && <TooltipHelp title={tooltip} mini={'mini'} />}
        </th>
    );
}
SortDropdown.propTypes = {
    name: PropTypes.string.isRequired,
    ordering: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    label: PropTypes.node.isRequired,
    items: PropTypes.array.isRequired
};
